export default {
    "changelog.title": "Nouveautés et Mises à jour du Produit - CitoyenPro",
    "changelog.seo_description": "Suivez les dernières nouveautés, améliorations et fonctionnalités de CitoyenPro. Restez à jour pour préparer votre examen de citoyenneté avec les meilleurs outils.",
    "changelog.hero.title": "Historique des mises à jour",
    "changelog.hero.subtitle": "Découvrez les dernières mises à jour, améliorations et corrections apportées à CitoyenPro.",
    "changelog.nav.back_home": "Retour à l'accueil",

    "changelog.updates.v140.title": "Lecteur EPUB et Accessibilité pour tous",
    "changelog.updates.v140.date": "19 Avril 2026",
    "changelog.updates.v140.change1": "Intégration d'un lecteur complet pour lire le guide 'Découvrir le Canada' au format EPUB sans quitter l'application.",
    "changelog.updates.v140.change2": "Outil disponible gratuitement pour tous les utilisateurs (plan Gratuit inclus).",
    "changelog.updates.v140.change3": "Support complet du mode sombre et redimensionnement adaptatif sur mobile et écran large.",

    "changelog.updates.v130.title": "Internationalisation (Bilingue)",
    "changelog.updates.v130.date": "8 Février 2026",
    "changelog.updates.v130.change1": "Support complet du Français et de l'Anglais",
    "changelog.updates.v130.change2": "Traduction de toutes les questions et réponses (Quiz, Vrai/Faux, Examens)",
    "changelog.updates.v130.change3": "Adaptation de l'interface et des emails transactionnels",
    "changelog.updates.v130.change4": "Sélecteur de langue avec drapeaux",

    "changelog.updates.v120.title": "Lancement des abonnements Premium",
    "changelog.updates.v120.date": "23 Janvier 2026",
    "changelog.updates.v120.change1": "Nouveau système d'abonnement complet (Standard & Premium)",
    "changelog.updates.v120.change2": "Ajout des examens blancs chronométrés",
    "changelog.updates.v120.change3": "Tableau de bord repensé pour un meilleur suivi",
    "changelog.updates.v120.change4": "Intégration des paiements sécurisés Stripe",

    "changelog.updates.v110.title": "Amélioration de l'expérience mobile",
    "changelog.updates.v110.date": "10 Janvier 2026",
    "changelog.updates.v110.change1": "Interface entièrement responsive sur mobile et tablette",
    "changelog.updates.v110.change2": "Mode sombre optimisé pour réduire la fatigue oculaire",
    "changelog.updates.v110.change3": "Nouvelle barre de navigation latérale sur Desktop",

    "changelog.updates.v100.title": "Lancement officiel de CitoyenPro",
    "changelog.updates.v100.date": "1 Janvier 2026",
    "changelog.updates.v100.change1": "Plus de 2000 questions basées sur le guide officiel",
    "changelog.updates.v100.change2": "Système de répétition espacée pour les flashcards",
    "changelog.updates.v100.change3": "Authentification email sécurisée",
    "changelog.updates.v100.change4": "Score de préparation intelligent"
};
